import { decimalFormatter } from '@/utils/number-formatters';

export function fromMillicoresToDecimal(value: number) {
  return decimalFormatter.format(value / 1000);
}
